import { useEffect, useState } from "react";
import "./index.css";
import { useDispatch, useSelector } from "react-redux";
import CountUp from "react-countup";
import LoginIcon from "@mui/icons-material/Login";
import LogoutIcon from "@mui/icons-material/Logout";
import CloseIcon from "@mui/icons-material/Close";
import DoDisturbAltIcon from "@mui/icons-material/DoDisturbAlt";
import Linechart from "./LineChart/Index";
import { KeyboardArrowDown } from "@mui/icons-material";
import PieChart from "./Piechart/Index";
import DropdownMenu from "../../Components/Atoms/DropdownMenu";
import { Button } from "@mui/material";
import {
  DASHBOARD_ICON_1,
  DASHBOARD_ICON_2,
  DASHBOARD_ICON_3,
  DASHBOARD_ICON_4,
} from "../../Constant";
import {
  getDashboardCardRequest,
  getDashboardLineChartMonthlyRequest,
  getDashboardLineChartYearlyRequest,
  getDashboardPieCreatedByRequest,
  getDashboardPieEmployeeRequest,
  getDashboardPieGroupByPurposeRequest,
  getDashboardPieStatusRequest,
} from "../../Redux/Dashboard/DashboardActions";

const Dashboard = () => {
  const {
    getDashboardCardLoading,
    getDashboardCardResponse,
    getDashboardPieEmployeeLoading,
    getDashboardPieEmployeeResponse,
    getDashboardPieStatusLoading,
    getDashboardPieStatusResponse,
    getDashboardPieGroupByPurposeLoading,
    getDashboardPieGroupByPurposeResponse,
    getDashboardPieCreatedByLoading,
    getDashboardPieCreatedByResponse,
    getDashboardLineMonthlyLoading,
    getDashboardLineMonthlyResponse,
    getDashboardLineYearlyLoading,
    getDashboardLineYearlyResponse,
  } = useSelector((state) => state.dashboardReducer);

  const datasets = [
    {
      id: 1,
      value: 20,
    },
    {
      id: 2,
      value: 60,
    },
    {
      id: 3,
      value: 10,
    },
    {
      id: 4,
      value: 10,
    },
    {
      id: 5,
      value: 20,
    },
    {
      id: 6,
      value: 60,
    },
    {
      id: 7,
      value: 10,
    },
  ];
  const dispatch = useDispatch();

  const ICONS = [
    DASHBOARD_ICON_1,
    DASHBOARD_ICON_2,
    DASHBOARD_ICON_3,
    DASHBOARD_ICON_4,
  ];

  const [employeeRoleMode, setEmployeeRoleMode] = useState("ALL");
  const [statusMode, setStatusMode] = useState("TODAY");
  const [purposeOfVisitMode, setPurposeOfVisitMode] = useState("TODAY");
  const [createdByMode, setCreatedByMode] = useState("TODAY");

  const [monthlyMode, setMonthlyMode] = useState("THIS_MONTH");
  const [yearlyMode, setYearlyMode] = useState("THIS_YEAR");

  useEffect(() => {
    dispatch(getDashboardCardRequest());
  }, []);

  useEffect(() => {
    dispatch(getDashboardPieEmployeeRequest({ mode: employeeRoleMode }));
  }, [employeeRoleMode]);

  useEffect(() => {
    dispatch(getDashboardPieStatusRequest({ mode: statusMode }));
  }, [statusMode]);

  useEffect(() => {
    dispatch(
      getDashboardPieGroupByPurposeRequest({ mode: purposeOfVisitMode }),
    );
  }, [purposeOfVisitMode]);

  useEffect(() => {
    dispatch(getDashboardPieCreatedByRequest({ mode: createdByMode }));
  }, [createdByMode]);

  useEffect(() => {
    dispatch(getDashboardLineChartMonthlyRequest({ mode: monthlyMode }));
  }, [monthlyMode]);

  useEffect(() => {
    dispatch(getDashboardLineChartYearlyRequest({ mode: yearlyMode }));
  }, [yearlyMode]);

  return (
    <>
      <div className="cntr">
        <div className="hdrComp">
          <h6>DASHBOARD STATISTICS</h6>
        </div>
      </div>
      <div className="dashboard_container mb-25">
        <div className="dashboard_grid_view">
          {["CHECKIN", "CHECKOUT"].map((each, index) => {
            return (
              <div key={index} className="dshStCard">
                <div className="rtTxtIfo">
                  <label>
                    {each === "CHECKIN"
                      ? "CHECK-IN"
                      : each === "CHECKOUT"
                        ? "CHECK-OUT"
                        : each}
                  </label>
                  <h2>
                    <CountUp
                      delay={1}
                      end={getDashboardCardResponse?.data?.[each]}
                    />
                  </h2>
                </div>
                <img className="dashboard_icon" src={ICONS[index]} />
              </div>
            );
          })}
        </div>
      </div>
      <div className="pie d-flex-juscon-sb-align-center mb-25 gap-2">
        <div className="chart-container">
          <div className="d-flex-juscon-sb-align-center gap-15">
            <h3 className="chart-subject">USER'S ROLE</h3>
            <DropdownMenu
              menuList={[
                {
                  label: "Active",
                  onClick: () => setEmployeeRoleMode("ACTIVE"),
                },
                {
                  label: "Inactive",
                  onClick: () => setEmployeeRoleMode("INACTIVE"),
                },
                {
                  label: "All",
                  onClick: () => setEmployeeRoleMode("ALL"),
                },
              ]}
            >
              <Button variant="outlined" color="secondary">
                <span
                  className="text-start text-capitalize"
                  style={{ width: "120px" }}
                >
                  {employeeRoleMode === "ACTIVE"
                    ? "Active"
                    : employeeRoleMode === "INACTIVE"
                      ? "Inactive"
                      : "All"}
                </span>
                <KeyboardArrowDown className="ms-2" />
              </Button>
            </DropdownMenu>
          </div>
          <div className="d-flex-juscon-center-align-center mt-5 mb-15 fd-column">
            <PieChart dataset={getDashboardPieEmployeeResponse?.data} />
          </div>
        </div>
        <div className="chart-container">
          <div className="d-flex-juscon-sb-align-center gap-15">
            <h3 className="chart-subject">VISITOR'S STATUS</h3>
            <DropdownMenu
              menuList={[
                {
                  label: "Today",
                  onClick: () => setStatusMode("TODAY"),
                },
                {
                  label: "Yesterday",
                  onClick: () => setStatusMode("YESTERDAY"),
                },
              ]}
            >
              <Button variant="outlined" color="secondary">
                <span
                  className="text-start text-capitalize"
                  style={{ width: "120px" }}
                >
                  {statusMode === "TODAY" ? "Today" : "Yesterday"}
                </span>
                <KeyboardArrowDown className="ms-2" />
              </Button>
            </DropdownMenu>
          </div>
          <div className="d-flex-juscon-center-align-center mt-5 mb-15 fd-column">
            <PieChart dataset={getDashboardPieStatusResponse?.data} />
          </div>
        </div>
        <div className="chart-container">
          <div className="d-flex-juscon-sb-align-center gap-15">
            <h3 className="chart-subject">GROUP BY PURPOSE</h3>
            <DropdownMenu
              menuList={[
                {
                  label: "Today",
                  onClick: () => setPurposeOfVisitMode("TODAY"),
                },
                {
                  label: "Yesterday",
                  onClick: () => setPurposeOfVisitMode("YESTERDAY"),
                },
              ]}
            >
              <Button variant="outlined" color="secondary">
                <span
                  className="text-start text-capitalize"
                  style={{ width: "120px" }}
                >
                  {purposeOfVisitMode === "TODAY" ? "Today" : "Yesterday"}
                </span>
                <KeyboardArrowDown className="ms-2" />
              </Button>
            </DropdownMenu>
          </div>
          <div className="d-flex-juscon-center-align-center mt-5 mb-15 fd-column">
            <PieChart dataset={getDashboardPieGroupByPurposeResponse?.data} />
          </div>
        </div>
        <div className="chart-container">
          <div className="d-flex-juscon-sb-align-center gap-15">
            <h3 className="chart-subject">GROUP BY VERIFIED BY </h3>
            <DropdownMenu
              menuList={[
                {
                  label: "Today",
                  onClick: () => setCreatedByMode("TODAY"),
                },
                {
                  label: "Yesterday",
                  onClick: () => setCreatedByMode("YESTERDAY"),
                },
              ]}
            >
              <Button variant="outlined" color="secondary">
                <span
                  className="text-start text-capitalize"
                  style={{ width: "120px" }}
                >
                  {createdByMode === "TODAY" ? "Today" : "Yesterday"}
                </span>
                <KeyboardArrowDown className="ms-2" />
              </Button>
            </DropdownMenu>
          </div>
          <div className="d-flex-juscon-center-align-center mt-5 mb-15 fd-column">
            <PieChart dataset={getDashboardPieCreatedByResponse?.data} />
          </div>
        </div>
      </div>
      <div className="line-chart d-flex-juscon-sb-align-center gap-2">
        <div className="chart-container">
          <div className="d-flex-juscon-sb-align-center gap-15">
            <h3 className="chart-subject">VISITOR'S BY MONTH</h3>
            <DropdownMenu
              menuList={[
                {
                  label: "This Month",
                  onClick: () => setMonthlyMode("THIS_MONTH"),
                },
                {
                  label: "Last Month",
                  onClick: () => setMonthlyMode("LAST_MONTH"),
                },
              ]}
            >
              <Button variant="outlined" color="secondary">
                <span
                  className="text-start text-capitalize"
                  style={{ width: "120px" }}
                >
                  {monthlyMode === "THIS_MONTH" ? "This Month" : "Last Month"}
                </span>
                <KeyboardArrowDown className="ms-2" />
              </Button>
            </DropdownMenu>
          </div>
          <div className="line_chart_container mt-2">
            <Linechart
              dataset={getDashboardLineMonthlyResponse?.data}
              mode="MONTH"
            />
          </div>
        </div>
        <div className="chart-container">
          <div className="d-flex-juscon-sb-align-center gap-15">
            <h3 className="chart-subject">VISITOR'S BY YEAR</h3>
            <DropdownMenu
              menuList={[
                {
                  label: "This Year",
                  onClick: () => setYearlyMode("THIS_YEAR"),
                },
                {
                  label: "Last Year",
                  onClick: () => setYearlyMode("LAST_YEAR"),
                },
              ]}
            >
              <Button variant="outlined" color="secondary">
                <span
                  className="text-start text-capitalize"
                  style={{ width: "120px" }}
                >
                  {yearlyMode === "THIS_YEAR" ? "This Year" : "Last Year"}
                </span>
                <KeyboardArrowDown className="ms-2" />
              </Button>
            </DropdownMenu>
          </div>
          <div className="line_chart_container mt-2">
            <Linechart
              dataset={getDashboardLineYearlyResponse?.data}
              mode={"YEAR"}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
